import React, { Component } from 'react';

import '@assets/css/multiselect.css';

class Multiselect extends Component {
  state = {
    isMultiselectOpen: false,
    selectedItems: [],
    selectedItemsMap: {},
    searchPattern: ""
  };

  node = null;

  // eslint-disable-next-line react/no-deprecated
  UNSAFE_componentWillMount() {
    document.addEventListener("mousedown", this.handleClickOutside, false);
  };

  componentDidMount() {
    this.onNewDataIncome();
  };

  onNewDataIncome = () => {
    const selectedItemsMap = {};
    const { selectedItems, items } = this.props;
    items.forEach(item => {
      const value = item.value;
      if (selectedItems.some(elem => elem.value === value)) {
        selectedItemsMap[value] = true;
      } else {
        selectedItemsMap[value] = false;
      }
    });

    this.setState({
      selectedItems: selectedItems,
      selectedItemsMap: selectedItemsMap
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.items.length !== prevProps.items.length
          || this.props.isError !== prevProps.isError ||
          this.props.selectedItems.length !== prevProps.selectedItems.length) {
      this.onNewDataIncome();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false);
  };

  handleClickOutside = (event) => {
    if (this.node && this.node.contains(event.target)) {
      return;
    }

    this.setState({
      isMultiselectOpen: false
    });
  };

  handleSearchChange = (event) => {
    this.setState({
      searchPattern: event.target.value
    });
  };

  getSelectedItems = () => {
    const { withId } = this.props;
    return this.state.selectedItems.map(item => withId ? `${item.method} (${item.value})` : item.label).join(", ");
  };

  getFilteredItems = () => {
    const { withId } = this.props;
    const searchPattern = this.state.searchPattern.toLowerCase();
    const filteredItems = this.props.items.filter(item => {
      const label = withId ? `${item.label} (${item.value})` : item.label;
      if (label.toLowerCase().includes(searchPattern)) {
        return true;
      }

      return false;
    });

    filteredItems.sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));

    return filteredItems;
  };

  updateSelectedMap = (event, value) => {
    const { selectedItems, selectedItemsMap } = this.state;
    const { type, items, onChange } = this.props;
    const isChecked = event.target.checked;
    if (isChecked) {
      selectedItems.push(
        Object.assign({}, items.find(item => item.value === value))
      );
      selectedItemsMap[value] = true;
    } else {
      const removeIndex = selectedItems.findIndex(item => item.value === value);
      selectedItems.splice(removeIndex, 1);
      selectedItemsMap[value] = false;
    }

    onChange(selectedItems, type);

    this.setState({
      selectedItems: selectedItems,
      selectedItemsMap: selectedItemsMap,
    });
  };

  onSelectAllClick = () => {
    const { selectedItems, selectedItemsMap } = this.state;
    const { type, items, onChange } = this.props;
    items.forEach(item => {
      const value = item.value;
      if (selectedItemsMap[value]) {
        return item;
      } else {
        selectedItemsMap[value] = true;
        selectedItems.push(Object.assign({}, item));
      }
    });

    onChange(selectedItems, type);

    this.setState({
      selectedItemsMap: selectedItemsMap,
      selectedItems: selectedItems
    });
  };

  onDeselectAllClick = () => {
    const { selectedItems, selectedItemsMap } = this.state;
    const { type, items, onChange } = this.props;
    items.forEach(item => {
      const value = item.value;
      if (!selectedItemsMap[value]) {
        return item;
      } else {
        selectedItemsMap[value] = false;
        const removeIndex = selectedItems.findIndex(selectedItem => selectedItem.value === item.value);
        selectedItems.splice(removeIndex, 1);
      }
    });

    onChange(selectedItems, type);

    this.setState({
      selectedItemsMap: selectedItemsMap,
      selectedItems: selectedItems
    });
  };

  render() {
    const { isMultiselectOpen, searchPattern } = this.state;
    const { withId, disabled, id } = this.props;

    return (
      <div
        ref={ node => this.node = node }
        className='customMultiselect'>
        <div onClick={ () => this.setState({ isMultiselectOpen: !isMultiselectOpen}) }>
          <input
            id={ id }
            disabled={ disabled }
            readOnly={ !disabled }
            style={ { paddingRight: "40px" } }
            className={ "form-control multiselect-results " + (this.props.isError ? "multiselect-error" : "") }
            value={ this.getSelectedItems() || "No items selected." }
          />
          <span className={ "select-arrow " + (isMultiselectOpen ? "select-arrow-open" : "") }>
            <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
          </span>
        </div>
        { isMultiselectOpen && (
          <div className="multiselect-items">
            <div className="search">
              <input
                type="text"
                placeholder="Search..."
                className="form-control"
                onChange={ (event) => this.handleSearchChange(event) }/>
            </div>
            <div className="select-functionality">
              <div
                className="select-all"
                onClick={ () => this.onSelectAllClick() }>
                  Select All
              </div>
              <div
                className="deselect-all"
                onClick={ () => this.onDeselectAllClick() }>
                  Deselect All
              </div>
            </div>
            <div className="items">
              { this.getFilteredItems().map(item => {
                return (
                  <label
                    key={ item.value }
                    htmlFor={ item.value }
                    className={ `select-item ${this.state.selectedItemsMap[item.value] && "checked"}` }
                  >
                    { withId ? `${item.method} (${item.value})` : item.label }
                    <input
                      type="checkbox"
                      name="item"
                      value={ searchPattern }
                      className="custom-checkbox"
                      id={ item.value }
                      checked={ this.state.selectedItemsMap[item.value] }
                      onChange={ (event) => this.updateSelectedMap(event, item.value) }/>
                    <label className="select-checkbox" htmlFor={ item.value }/>
                  </label>
                );
              })
              }
            </div>
          </div>
        )}
      </div>
    );
  }

}

export default Multiselect;